import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import {
  PaginatedVendors,
  PatchVendorRequestBody,
  PostVendorRequestBody,
  Vendor,
  GetVendorsQueryParams,
  S3SignedUrl
} from "src/types";
import { PostVendorsExportsRequestBody } from "src/types/api/vendor/postVendorsExports";
import { PostVendorsBulkEmailRequestBody, SendBulkEmailResult } from "src/types/api/vendor/postVendorsBulkEmail";

class VendorAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/vendors");
  }

  async getVendors(queryParams?: GetVendorsQueryParams): Promise<PaginatedVendors> {
    return await this.jwtRequest("GET", "", undefined, queryParams);
  }

  async getVendorNames(bypassCache?: boolean): Promise<string[]> {
    const path = `/names`;

    const queryParams = new URLSearchParams();
    if (bypassCache) {
      queryParams.append("bypassCache", "true");
    }

    const fullPath = queryParams.toString() ? `${path}?${queryParams.toString()}` : path;

    return await this.jwtRequest("GET", fullPath, undefined);
  }

  async getVendorLocations(): Promise<string[]> {
    const path = `/locations`;

    return await this.jwtRequest("GET", path, undefined);
  }

  async getVendorByName(vendorName: string): Promise<Vendor> {
    const path = `/name`;

    return await this.jwtRequest("GET", path, undefined, { vendorName });
  }

  async getVendorById(vendorId: string): Promise<Vendor> {
    const pathParam = encodeURIComponent(vendorId);
    const path = `/${pathParam}`;

    return await this.jwtRequest("GET", path);
  }

  async patchVendor(vendorId: string, requestBody: PatchVendorRequestBody): Promise<Vendor> {
    const pathParam = encodeURIComponent(vendorId);
    const path = `/${pathParam}`;

    return await this.jwtRequest("PATCH", path, requestBody);
  }

  async deleteVendor(vendorId: string): Promise<void> {
    const pathParam = encodeURIComponent(vendorId);
    const path = `/${pathParam}`;

    return await this.jwtRequest("DELETE", path);
  }

  async postVendor(requestBody: PostVendorRequestBody): Promise<Vendor> {
    return await this.jwtRequest("POST", undefined, requestBody);
  }

  async postVendorsExports(requestBody: PostVendorsExportsRequestBody): Promise<S3SignedUrl> {
    const path = `/exports`;

    return await this.jwtRequest("POST", path, requestBody);
  }

  async postVendorsBulkEmail(requestBody: PostVendorsBulkEmailRequestBody): Promise<SendBulkEmailResult> {
    const path = `/bulk-email`;

    return await this.jwtRequest("POST", path, requestBody);
  }
}

export { VendorAPIService };
